<script lang="ts">
    import { login } from "../../../store"
    import { icons } from "../../../config"
    import { _ } from "svelte-i18n"
    import Icon from "../../widgets/Icon.svelte"
    import { initialLocale } from "../../../i18n"

    export let isOut = false
    export let type = 1
</script>

<!-- Tabnavi -->
<div class="tabnavi-row">
    <div class="col">
        {#if $login?.account.roles?.includes("A") || $login?.account.permissions?.includes("O")}
            <div class="tabnavi-title">{$_("general.entrance")}</div>
        {/if}
        <ul class="tabnavi">
            <li>
                <a class:active="{!isOut && type == 1}" href="/{initialLocale}/operations?type=1">
                    <span class="icon">
                        <Icon path="{icons.offerIn}" viewBox="0 0 214.13 214.13" />
                    </span>
                    <span class="text">{$_("bookmarks.offers")}</span>
                </a>
            </li>
            <li>
                <a class:active="{!isOut && type == 2}" href="/{initialLocale}/operations?type=2">
                    <span class="icon">
                        <Icon path="{icons.order}" viewBox="0 0 180.2 203.87" />
                    </span>
                    <span class="text">{$_("bookmarks.orders")}</span>
                </a>
            </li>
        </ul>
    </div>
    {#if $login?.account.roles?.includes("A") || $login?.account.permissions?.includes("O")}
        <div class="col right">
            <div>
                <div class="tabnavi-title">{$_("general.exit")}</div>
                <ul class="tabnavi">
                    <li>
                        <a class:active="{isOut && type == 1}" href="/{initialLocale}/operations-out?type=1">
                            <span class="icon">
                                <Icon path="{icons.offerOut}" viewBox="0 0 200 200" />
                            </span>
                            <span class="text">{$_("bookmarks.offers")}</span>
                        </a>
                    </li>
                    <li>
                        <a class:active="{isOut && type == 2}" href="/{initialLocale}/operations-out?type=2">
                            <span class="icon">
                                <Icon path="{icons.order}" viewBox="0 0 180.2 203.87" />
                            </span>
                            <span class="text">{$_("bookmarks.orderConfirmations")}</span>
                        </a>
                    </li>
                </ul>
            </div>
        </div>
    {/if}
</div>
